export const NAME = 'groups'
export const LABEL = 'Grupy'
export const PATH = `/${NAME}/`
export const PATH_PL = `/grupy/`
